import { PlannerEnv, envToBaseUrl } from '@/utils/env';
import Fetch from '../fetch/Fetch';
import { PlannerConfigEntity } from './PlannerConfigTypes';

export type ReleaseOptions = {
  forceUpdatePhraseKeys?: boolean;
};

export class Release {
  private baseUrl;

  constructor(env: PlannerEnv) {
    this.baseUrl = `${envToBaseUrl(env)}`;
  }

  public async release(id: string, options?: ReleaseOptions) {
    const params = new URLSearchParams();
    if (options?.forceUpdatePhraseKeys) {
      params.set('forceUpdatePhraseKeys', 'true');
    }
    const queryString = params.toString();
    const url = `${this.baseUrl}/release/${id}${queryString ? `?${queryString}` : ''}`;

    const response = await Fetch.json(url);
    //@ts-expect-error - response.data is not defined in Fetch.json
    return response.data as PlannerConfigEntity[];
  }
}
